import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// material-ui
import { Box, Button, Grid, InputAdornment, OutlinedInput } from '@mui/material';
import { IconSearch } from '@tabler/icons';
import AddIcon from '@mui/icons-material/Add';

// project imports
import VenueList from './VenueList';
import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';
import PaginationRows from 'ui-component/extended/PaginationRows';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';
import MasterService from 'services/MasterService';

const Venue = () => {

    const navigate = useNavigate();
    const [total, setTotal] = useState(1);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [limit, setLimit] = useState(10);
    const [rows, setRows] = useState([]);
    const [reload, setReload] = useState(false);
    const [sportsTypes, setSportsType] = useState([])

    const handleAddVenue = () => {
        navigate('/venue/create');
    };

    const changeSearch = (e) => {
        setSearchText(e.target.value);
        setPage(1);
    };

    const handleSuccess = (response) => {
        const data = response.data;
        setRows(data.rows);
        setTotal(data.filtered);
    };

    const getStHandler = (response) => {
        const data = response.data
        setSportsType(data)
    }

    const venueListApi = useApi(VenueService.getVenueList, handleSuccess);
    const getSportsTypeListApi = useApi(MasterService.getDropdownSportsType, getStHandler)

    useEffect(() => {
        venueListApi.execute({
            limit,
            skip: (page * limit) - limit,
            searchValue: searchText.trim(),
        });
    }, [searchText, page, limit, reload]);

    useEffect(() => {
        getSportsTypeListApi.execute();
    }, []);

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard
                title={
                    <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
                        <Grid item xs={12} md={3}>
                            <Box>
                                <OutlinedInput
                                    id="input-search-list-style1"
                                    placeholder="Search venue, owner name..."
                                    fullWidth
                                    sx={{ maxWidth: '300px' }}
                                    value={searchText}
                                    onChange={changeSearch}
                                    startAdornment={
                                        <InputAdornment position="start">
                                            <IconSearch stroke={1.5} size="16px" />
                                        </InputAdornment>
                                    }
                                    size="small"
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Grid
                                container
                                justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
                                alignItems="center"
                                spacing={gridSpacing}
                            >
                                <Grid item>
                                    <Button
                                        startIcon={<AddIcon />}
                                        variant="contained"
                                        color="secondary"
                                        onClick={handleAddVenue}
                                    >
                                        Venue Onboard
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
                content={false}
            >
                <VenueList
                    rows={rows}
                    limit={limit}
                    page={page}
                    setReload={setReload}
                    sportsTypes={sportsTypes}
                />
                <PaginationRows
                    total={total}
                    page={page}
                    setPage={setPage}
                    limit={limit}
                    setLimit={setLimit}
                    limits={[10, 15, 20]}
                />
            </MainCard>
        </Box>
    );
};

export default Venue;
